import "../../../../../../lib/assets/javascripts/assert.js";
import "./availability_badge.js";

window.Sparkle ??= {};
window.Sparkle.WalkInAvailability ??= {};

Sparkle.WalkInAvailability.WaitTimeBadge = class WaitTimeBadge extends Sparkle.WalkInAvailability.AvailabilityBadge {
  constructor(resourceKey, templates, options = {}) {
    const _options = jQuery.extend({ update: true, state: { open: true, waitTime: null } });
    const assert = new Asserter();
    templates.template = assert.element(templates.template);

    super(resourceKey, templates, _options);
    this.update = this.update.bind(this);
    this.showBadgeCalls = this.showBadgeCalls.bind(this);
    this.setBadgeStatus = this.setBadgeStatus.bind(this);
    this.setWalkInContent = this.setWalkInContent.bind(this);
    this.setLocationURL = this.setLocationURL.bind(this);
    this.timeAmount = this.timeAmount.bind(this);
    this.renderWaittime = this.renderWaittime.bind(this);
    this.generateWaitLabelText = this.generateWaitLabelText.bind(this);
    this.templates = templates;
    this.options = _options;
  }

  // PROTECTED

  update(state) {
    super.update(state);
    return this.showBadge(this.templates.template, this.currentState);
  }

  showBadgeCalls(content, state) {
    if (state.open) {
      this.renderWaittime(content, state.waitTime);
    } else {
      this.renderNextOpenAt(content, state.nextOpenAt);
    }

    this.setBadgeStatus(content, state);
    this.setWalkInContent(content, state.walkInContent);
    return this.setLocationURL(content, state.url);
  }

  // PRIVATE

  setBadgeStatus(badge, state) {
    let badgeState;
    if ((state != null ? state.waitTime : undefined) == null || state.stale) {
      badgeState = "hidden";
    } else if (!state.open) {
      badgeState = "closed";
    } else if (
      state.waitTime.includes("h") ||
      (state.waitTime.includes("minutes") && this.timeAmount(state.waitTime) > 35)
    ) {
      badgeState = "longWait";
    } else if (this.timeAmount(state.waitTime) >= 0) {
      // Include zero - will display 'No wait'
      badgeState = "shortWait";
    }

    return badge.filter("[data-wait-badge]").each(function () {
      return jQuery(this).attr("data-wait-badge-state", badgeState);
    });
  }

  setWalkInContent(badge, walkInContent) {
    return badge.find("[data-walk-in-content]").each(function () {
      return jQuery(this).html(walkInContent);
    });
  }

  setLocationURL(badge, url) {
    return badge.find("[data-location-url]").each(function () {
      return jQuery(this).attr("href", url + "?tab=tab_hours");
    });
  }

  timeAmount(waitTime) {
    return waitTime.replace(/(^\d+)(.+$)/i, "$1");
  }

  renderWaittime(badge, waitTime) {
    const text = this.generateWaitLabelText(waitTime);

    badge.find("[data-queue-display-number]").each(function () {
      return jQuery(this).html(waitTime);
    });

    return badge.find("[data-queue-display-text]").each(function () {
      return jQuery(this).html(text);
    });
  }

  generateWaitLabelText(time) {
    if (!time) {
      return null;
    }

    if (time.length > 0) {
      return "Approximate wait:";
    } else {
      return "No wait";
    }
  }
};
